const objeto11 = {
    titulo: `Objetos: Sintaxis de subclases`,
    problemas: [
      {
        codigo: 1,
        descripcion: `El JavaScript moderno también soporta el concepto de herencia o subclases. 
Las clases de JavaScript pueden extender de otras clases:
<code>
class ClasePadre {
}

class ClaseHija extends ClasePadre {
}
</code>
La clase Hija tendrá todas las propiedades y métodos de la clase padre, además de cualquier propiedad y método que ella misma defina.
Confeccionar una clase Persona que tenga como atributos el nombre y la edad. Al constructor llegan los datos personales y en otro método se imprimen.
Plantear una segunda clase Empleado que herede de la clase Persona. Añadir un atributo sueldo y los métodos constructor, imprimir y un método si debe pagar impuestos (sueldo mayor a 5000)
<code>
class Persona {
    constructor(nombre, edad) {
      this.nombre = nombre
      this.edad = edad
    }

    imprimir() {
      console.log('Nombre:' + this.nombre)
      console.log('Edad:' + this.edad)
    }
  }

  class Empleado extends Persona {
    constructor(nombre, edad, sueldo) {
      super(nombre, edad)
      this.sueldo = sueldo
    }

    imprimir() {
      super.imprimir()
      console.log('Sueldo:' + this.sueldo)
    }

    pagaImpuestos() {
      if (this.sueldo > 5000)
        console.log(this.nombre + ' debe pagar impuestos')
      else
        console.log(this.nombre + ' no debe pagar impuestos')
    }
  }


  const persona1 = new Persona('Juan', 44)
  persona1.imprimir()

  const empleado1 = new Empleado('Juan', 44, 7000)
  empleado1.imprimir()
  empleado1.pagaImpuestos()
  </code>
La clase Empleado hereda de la clase Persona (es decir que la clase Empleado tiene como atributos su nombre, edad un método donde se inicializan dichos atributos y uno que los muestra)
Mediante la sintaxis de extends indicamos que Empleado hereda de Persona. En el constructor recibe como parámetros el nombre del empleado, su edad y el sueldo. Los atributos del nombre y edad se los pasamos al constructor de la clase padre mediante la palabra clave 'super'.
El constructor de la clase Empleado debe llamar al constructor de la clase persona en forma obligatoria mediante la palabra clave super (si el constructor de la clase padre tiene parámetros, deben ser pasados también).
Lo mismo en el método imprimir del Empleado llamamos al imprimir de la clase padre mediante la palabra clave super para que se muestren el nombre y edad del empleado. `,
        programa: `class Persona {
  constructor(nombre, edad) {
    this.nombre = nombre
    this.edad = edad
  }

  imprimir() {
    console.log('Nombre:' + this.nombre)
    console.log('Edad:' + this.edad)
  }
}

class Empleado extends Persona {
  constructor(nombre, edad, sueldo) {
    super(nombre, edad)
    this.sueldo = sueldo
  }

  imprimir() {
    super.imprimir()
    console.log('Sueldo:' + this.sueldo)
  }

  pagaImpuestos() {
    if (this.sueldo > 5000)
      console.log(this.nombre + ' debe pagar impuestos')
    else
      console.log(this.nombre + ' no debe pagar impuestos')
  }
}


const persona1 = new Persona('Juan', 44)

const empleado1 = new Empleado('Maria', 22, 7000)
empleado1.pagaImpuestos()`,
        solucion: "'Maria debe pagar impuestos'",
      }, {
        codigo: 2,
        descripcion: `En el siguiente problema declaramos una clase llamada Publicacion y dos subclases, una que representa un Libro y otra que representa un Video.
Los libros y videos tienen en común que tienen un título y un autor, pero la funcionalidad de informar si el libro o el video es largo depende de la subclase que lo implemente, además un libro tiene una propiedad que es la cantidad de hojas y un video tiene una propiedad que almacena la duración en minutos. Un libro es largo si tiene más de 300 páginas, y un video es largo si tiene más de 60 minutos.`,
        programa: `class Publicacion {
  constructor(titulo, autor) {
    this.titulo = titulo
    this.autor = autor
  }
}

class Libro extends Publicacion {
  constructor(titulo, autor, numeroPaginas) {
    super(titulo, autor)
    this.numeroPaginas = numeroPaginas
  }

  esExtenso() {
    return this.numeroPaginas > 300
  }
}

class Video extends Publicacion {
  constructor(titulo, autor, duracion) {
    super(titulo, autor)
    this.duracion = duracion
  }

  esExtenso() {
    return this.duracion > 60
  }
}

const video1 = new Video('Video 1', 'Juan', 92)
if (video1.esExtenso()) {
console.log('El video es extenso')
} else {
console.log('El video no es extenso')
}`,
        solucion: "'El video es extenso'",
      }
    ]
  }
  
  export default objeto11;